import React, { useEffect, useState } from "react";
import { Modal, Spin, Tooltip, Collapse } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./_WorkflowTarefaModal.less";
import {
  etapaByIdSelector,
  fetchWorkflowTarefa,
  logsByTarefaIdSelector,
  removeWorkflowTarefaMembro,
  selectedTarefaSelector,
  selectWorkflowTarefaId,
  tarefasAnexosSelector,
  tarefasItensSelector,
  tarefasMembrosSelector,
  tipoTarefaByIdSelector,
  updateWorkflowTarefaAcesso,
  updateWorkflowTarefaDataEntrega,
  updateWorkflowTarefaDataPrazo,
  updateWorkflowTarefaDescricao,
  updateWorkflowTarefaEmpresa,
  updateWorkflowTarefaNome,
  updateWorkflowTarefaObservacao,
  updateWorkflowTarefaUnidade,
  updateWorkflowTarefaModulo,
  workflowSelector,
  fetchWorkflowTarefaLogs,
  updateWorkflowTarefaDataInicio,
} from "../../../store/workflow";
import { useSelector } from "react-redux";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import WorkflowTipoTarefaTag from "../_WorkflowTipoTarefaTag";
import { UserOutlined } from "@ant-design/icons";
import ActionLink from "../../../components/action-link";
import ActionBar from "../../../components/action-bar";
import WorkflowTarefaDescricao from "./_WorkflowTarefaDescricao";
import WorkflowTarefaNome from "./_WorkflowTarefaNome";
import WorkflowTarefaDataEntrega from "./_WorkflowTarefaDataEntrega";
import useFormatter from "../../../hooks/useFormatter";
import moment from "moment";
import WorkflowTarefaItemCriar from "./_WorkflowTarefaItemCriar";
import WorkflowTarefaItem from "./_WorkflowTarefaItem";
import WorkflowTarefaMembroAdicionar from "./_WorkflowTarefaMembroAdicionar";
import useLoading from "../../../hooks/useLoading";
import WorkflowTarefaAnexoCriar from "./_WorkflowTarefaAnexoCriar";
import WorkflowTarefaAnexo from "./_WorkflowTarefaAnexo";
import { isClienteGestorSelector, isClienteOperadorSelector, usuarioIdSelector } from "../../../store/autenticacao";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import SelectWorkflowEmpresa from "./_SelectWorkflowEmpresa";
import SelectWorkflowUnidade from "./_SelectWorkflowUnidade";
import WorkflowTarefaObservacao from "./_WorkflowTarefaObservacao";
import SelectWorkflowAcesso from "./_SelectWorkflowAcesso";
import SelectWorkflowModulo from "./_SelectWorkflowModulo";
import WorkflowTarefaArquivamento from "./_WorkflowTarefaDataArquivamento";
import WorkflowTarefaDataPrazo from "./_WorkflowTarefaDataPrazo";
import WorkflowTarefaDataInicio from "./_WorkflowTarefaDataInicio";
import WorkflowTarefaDataInclusao from "./_WorkflowTarefaDataInclusao";

export default function WorkflowTarefaModal() {
  const { t } = useTranslation();
  const { formatDateTime } = useFormatter();
  const dispatch = useDispatchWithResult();
  const isClienteOperador = useSelector(isClienteOperadorSelector);
  const isClienteGestor = useSelector(isClienteGestorSelector);
  const usuarioId = useSelector(usuarioIdSelector);
  const loading = useLoading(fetchWorkflowTarefa.typePrefix);
  const { id, nome, descricao, createdAt, dataPrazo, dataEntrega, dataInicio, modulo, acesso, dataArquivamento, empresa, unidade, observacao, ...tarefa } = useSelector(selectedTarefaSelector);
  const workflow = useSelector(workflowSelector);
  const membros = useSelector(tarefasMembrosSelector(id));
  const anexos = useSelector(tarefasAnexosSelector(id));
  const itens = useSelector(tarefasItensSelector(id));
  const logs = useSelector(logsByTarefaIdSelector(id));
  const etapa = useSelector(etapaByIdSelector(tarefa.etapa));
  const tipoTarefa = useSelector(tipoTarefaByIdSelector(tarefa.tipoTarefa));
  const [now, setNow] = useState(Date.now());

  const workflowId = workflow.id;

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(interval);
  }, []);

  const handleNomeSubmit = (nome) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaNome({ workflowId, id, nome })));
  const handleDescricaoSubmit = (descricao) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaDescricao({ workflowId, id, descricao })));
  const handleDataPrazoSubmit = (dataPrazo) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaDataPrazo({ workflowId, id, dataPrazo })));
  const handleDataEntregaSubmit = (dataEntrega) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaDataEntrega({ workflowId, id, dataEntrega })));
  const handleDataInicioSubmit = (dataInicio) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaDataInicio({ workflowId, id, dataInicio })));
  const handleModuloSubmit = (modulo) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaModulo({ workflowId, id, modulo })));
  const handleModuloUnload = () => unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
  const handleAcessoSubmit = (acessoId) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaAcesso({ workflowId, id, acessoId })));
  const handleAcessoUnload = () => unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
  const handleEmpresaSubmit = (empresaId) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaEmpresa({ workflowId, id, empresaId })));
  const handleEmpresaUnload = () => unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
  const handleUnidadeSubmit = (unidadeId) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaUnidade({ workflowId, id, unidadeId })));
  const handleUnidadeUnload = () => unwrapAxiosPromise(dispatch(fetchWorkflowTarefa({ workflowId, id })));
  const handleObservacaoSubmit = (observacao) => unwrapAxiosPromise(dispatch(updateWorkflowTarefaObservacao({ workflowId, id, observacao })));
  const handleMembroRemoveClick = (membroId) => unwrapAxiosPromise(dispatch(removeWorkflowTarefaMembro({ workflowId, id, membroId })));
  const handleCancel = (e) => dispatch(selectWorkflowTarefaId(null));
  const handleLogs = (e) => dispatch(fetchWorkflowTarefaLogs({ workflowId, id }));

  return (
    <Modal
      title={
        <div className={styles["titulo"]}>
          <div>
            <WorkflowTarefaNome nome={nome} onSubmit={handleNomeSubmit} readOnly={!isClienteOperador || dataArquivamento} />
            <div>({etapa.nome})</div>
          </div>
          <div>
            <WorkflowTipoTarefaTag {...tipoTarefa} />
          </div>
        </div>
      }
      open={id > 0}
      destroyOnClose
      footer={false}
      onCancel={handleCancel}
    >
      <Spin spinning={loading}>
        <div className={styles["workflow-tarefa-modal"]}>
          <div className={styles["cabecalho"]}>{t("Descrição")}</div>
          <div>
            <WorkflowTarefaDescricao descricao={descricao} onSubmit={handleDescricaoSubmit} readOnly={!isClienteOperador || dataArquivamento} />
          </div>
          <div className={styles["datas"]}>
            <div>
              <div className={styles["cabecalho"]}>{t("Inclusão")}</div>
              <div>
                <WorkflowTarefaDataInclusao dataInclusao={createdAt} readOnly={true} />
              </div>
            </div>
            <div>
              <div className={styles["cabecalho"]}>{t("Data Início")}</div>
              <div>
                <WorkflowTarefaDataInicio dataEntrega={dataInicio} onSubmit={handleDataInicioSubmit} readOnly={!isClienteOperador || dataArquivamento} />
              </div>
            </div>
            <div>
              <div className={styles["cabecalho"]}>{t("Prazo")}</div>
              <div>
                <WorkflowTarefaDataPrazo dataPrazo={dataPrazo} onSubmit={handleDataPrazoSubmit} readOnly={!isClienteOperador || dataArquivamento} />
              </div>
            </div>
            <div>
              <div className={styles["cabecalho"]}>{t("Entrega")}</div>
              <div>
                <WorkflowTarefaDataEntrega dataEntrega={dataEntrega} onSubmit={handleDataEntregaSubmit} readOnly={!isClienteOperador || dataArquivamento} />
              </div>
            </div>
            {dataArquivamento && (
              <div>
                <div className={styles["cabecalho"]}>{t("Data Arq.")}</div>
                <div>
                  <WorkflowTarefaArquivamento dataArquivamento={dataArquivamento} />
                </div>
              </div>
            )}
          </div>
          <div className={styles["cabecalho"]}>{t("Módulo")}</div>
          <div>
            <SelectWorkflowModulo workflowId={workflowId} modulo={modulo} onSubmit={handleModuloSubmit} onUnload={handleModuloUnload} readOnly={!isClienteOperador || dataArquivamento} />
          </div>
          <div className={styles["cabecalho"]}>{t("Acesso")}</div>
          <div>
            <SelectWorkflowAcesso workflowId={workflowId} acesso={acesso} onSubmit={handleAcessoSubmit} onUnload={handleAcessoUnload} readOnly={!isClienteOperador || dataArquivamento} />
          </div>

          {!!acesso && <div className={styles["cabecalho"]}>{t("Empresa")}</div>}
          {!!acesso && (
            <div>
              <SelectWorkflowEmpresa workflowId={workflowId} acessoId={acesso?.id} empresa={empresa} onSubmit={handleEmpresaSubmit} onUnload={handleEmpresaUnload} readOnly={!isClienteOperador || dataArquivamento} modulo={modulo} />
            </div>
          )}
          {!!empresa && <div className={styles["cabecalho"]}>{t("Unidade")}</div>}
          {!!empresa && (
            <div>
              <SelectWorkflowUnidade workflowId={workflowId} acessoId={acesso?.id} empresaId={empresa?.id} unidade={unidade} onSubmit={handleUnidadeSubmit} onUnload={handleUnidadeUnload} readOnly={!isClienteOperador || dataArquivamento} />
            </div>
          )}
          <div className={styles["cabecalho"]}>{t("Membros")}</div>
          <div className={styles["conteudo"]}>
            {membros?.map((membro) => (
              <div key={membro.id} className={styles["item"]}>
                <div>
                  <UserOutlined />
                </div>
                <div>{membro.nome}</div>
                {(isClienteOperador || dataArquivamento || (isClienteOperador && membro.id !== usuarioId)) && (
                  <div>
                    <ActionBar>
                      <ActionLink.Remove noTitle onClick={() => handleMembroRemoveClick(membro.id)} />
                    </ActionBar>
                  </div>
                )}
              </div>
            ))}
            {isClienteOperador && !dataArquivamento && (
              <div>
                <WorkflowTarefaMembroAdicionar tarefaId={id} />
              </div>
            )}
          </div>
          <div>
            <div className={styles["cabecalho"]}>{t("Observação")}</div>
            <WorkflowTarefaObservacao observacao={observacao} onSubmit={handleObservacaoSubmit} readOnly={!isClienteOperador || dataArquivamento} />
          </div>
          <div className={styles["cabecalho"]}>{t("Anexos")}</div>
          <div className={styles["conteudo"]}>
            {anexos?.map((anexo) => (
              <WorkflowTarefaAnexo key={anexo.id} {...anexo} />
            ))}
            {isClienteOperador && !dataArquivamento && (
              <div>
                <WorkflowTarefaAnexoCriar tarefaId={id} />
              </div>
            )}
          </div>

          <div className={styles["cabecalho"]}>{t("Itens")}</div>
          <div className={styles["conteudo"]}>
            {itens?.map((item) => (
              <WorkflowTarefaItem key={item.id} {...item} />
            ))}
            {isClienteOperador && !dataArquivamento && (
              <div>
                <WorkflowTarefaItemCriar tarefaId={id} readOnly={!isClienteOperador || dataArquivamento} />
              </div>
            )}
          </div>
          <Collapse
            bordered={true}
            defaultActiveKey={[]}
            onChange={(activeKeys) => {
              handleLogs();
            }}
          >
            <Collapse.Panel header={t("Logs")} key="1">
              <div className={styles["logs"]}>
                {logs?.map((log) => (
                  <div key={log.id}>
                    <div>{log.texto}</div>
                    <div className={styles["log-autor"]}>
                      <Tooltip title={formatDateTime(log.createdAt)}>{moment(log.createdAt).fromNow()}</Tooltip>
                      <div>
                        {t("por")} <strong>{log.usuario.nome}</strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Collapse.Panel>
          </Collapse>
        </div>
      </Spin>
    </Modal>
  );
}
